import { notifications } from "@mantine/notifications";

export const notify = {
    ok: (message: string, title?: string) =>
        notifications.show({ message, title, color: "green" }),
    err: (message: string, title?: string) =>
        notifications.show({ message, title, color: "red" }),
};
